/**
 * @file useMatomo.ts
 * @module useMatomo
 * @description React āķis (hook) Matomo tīmekļa analītikas un Tag Manager inicializācijai.
 *              Ielādē Matomo izsekošanas skriptu un konteineru no konfigurētā galapunkta.
 *              Izmanto ražošanā, lai vāktu lietojuma analītiku marķieru komponentam,
 *              kas iegults SIPR sistēmas priekšpuses servisa formās.
 */

import { useEffect } from "react";

/**
 * Initializes Matomo analytics and Tag Manager on component mount.
 * No-op in development mode. Injects the matomo.js script tag
 * and configures tracking for the transportdata.gov.lv Matomo instance.
 */
export const useMatomo = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

      try {
        //@ts-expect-error
      const _paq = (window._paq = window._paq || []);
      const u = "https://transportdata.gov.lv/";

      _paq.push(["trackPageView"]);
      _paq.push(["enableLinkTracking"]);
      _paq.push(["setTrackerUrl", u + "matomo.php"]);
      _paq.push(["setSiteId", "1"]);

      // inject matomo.js
      const d = document;
      const g = d.createElement("script");
      const s = d.getElementsByTagName("script")[0];

      g.type = "text/javascript";
      g.async = true;
      g.src = u + "matomo.js";
      s.parentNode?.insertBefore(g, s);

          // Tag Manager
          //@ts-expect-error
      const _mtm = (window._mtm = window._mtm || []);
      _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    } catch (e) {
      console.error("Matomo initialization error", e);
    }
  }, []);
};
